<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">{{ label }} <span class="custom-error"
                v-if="(required)">*</span></label>
        <select :id="id" ref="input" v-model="selected" v-bind="{ ...$attrs, class: null }" class="form-select"
            :class="{ error: error }" @change="action" :required="required">
            <slot />
        </select>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>
<script>
import { v4 as uuid } from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `select-input-${uuid()}`
            },
        },
        error: String,
        label: String,
        required: Boolean,
        modelValue: [String, Number, Boolean],
        action: {
            type: Function,
            required: true
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            selected: this.modelValue,
        }
    },
    watch: {
        selected(selected) {
            this.$emit('update:modelValue', selected)
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    }
}
</script>
